import { html, rune, View } from 'rune-ts';
import klass from '../ProductList.module.scss';
import { staticTypoPcMo, typoPcMo } from '../../../../shared/typography/typo';

export class ProductListCount extends View<{ count: number; is_mobile?: boolean }> {
  override template() {
    const is_mobile = rune.getSharedData(this)?.is_mobile ?? this.data.is_mobile;
    return html`
      <span class="${klass.count}">
        <span class="${typoPcMo({ is_mobile, pc: '16_medium', mo: '14_medium' })}"
          >${ET('mps2::product::total')}</span
        >
        <span class="${staticTypoPcMo({ is_mobile, pc: 'unica_16_medium', mo: 'unica_14_medium' })}"
          >${this.data.count.toLocaleString()}</span
        ><span class="${typoPcMo({ is_mobile, pc: '16_medium', mo: '14_medium' })}"
          >${ET('mps2::product::count')}</span
        >
      </span>
    `;
  }

  setCount(count: number) {
    this.data.count = count;
    return this;
  }
}
